import { SSkuCard, SActionBtn, STableActions, SLowcodeList, SDrawerOrModal } from 'shj-components'
import { Button, Popconfirm, message, Tooltip, Modal } from 'antd'
import { useEffect, useRef, useState } from 'react'
import { selectForOnlineShop } from '@/services/goods';
import { orderReplaceGoods } from '@/services/order'
import styles from './index.module.less'

export default function EditCommodityModal({
  detailsInfo = {},
  onCancel = () => ({}),
  reloadPage = () => ({}),
  open = false
}) {
  const listRef = useRef<any>(null)

  const config = {
    rowSelection: true,
    rowSelectionType: 'radio',
    columns: [
      {
        title: '商品',
        dataIndex: 'specialCode',
        width: 350,
        name: 'specialCode',
        render: 'renderProduct',
      },
      {
        title: '品牌',
        dataIndex: 'brandName',
        width: 120,
        ellipsis: {
          showTitle: false,
        },
      },
      {
        title: '单位',
        dataIndex: 'unitName',
        width: 120,
        ellipsis: {
          showTitle: false,
        },
      },
    ],
    search: [
      {
        label: '商品名称',
        name: 'nameKey',
      },
    ],
  }

  const fetchList = async ({ current = 1, query }) => {
    try {
      const res = await selectForOnlineShop({
        params: {
          pageId: current,
          pageSize: 10
        },
        data: {
          orgId: detailsInfo.orgId,
          bizTagCode: detailsInfo.bizTag,
          showNameKey: query.nameKey,
          searchFlag: true,
        }
      })
      if (res) {
        return {
          records: res?.list,
          total: res?.count,
        };
      }
      return {
        records: [],
        total: 0,
      }
    } catch (err) {
      message.error('查询列表失败');
    }
  }

  const extensions = {
    request: { fetchList },
    customRender: {
      renderProduct(_, record: Record<string, any>) {
        return (
          <SSkuCard
            width={'100%'}
            url={record.mainFiles?.[0]?.urlSite || ''}
            desc={record.id}
            operation={() => {
              return <div></div>
            }}
            title={
              <Tooltip title={record.goodsName}>
                <div className={styles.showTwoLinehidden}>{record.goodsName}</div>
              </Tooltip>
            }
          ></SSkuCard>
        )
      },
    },
  }
  
  const handleConfirmEditCommodity = () => {
    if (!listRef?.current?.getSelectedRows()?.[0]?.[0]) {
      message.info('请先选择要替换的商品');
      return;
    }
    Modal.confirm({
      title: '提示',
      content: '请确认是否替换？',
      onOk: async () => {
        try {
          const row = listRef?.current?.getSelectedRows()?.[0];
          if (!row?.[0]) {
            message.info('请先选择要替换的商品');
            return;
          }
          const res = await orderReplaceGoods({
            orderId: detailsInfo?.orderId,
            quoteGoodsId: detailsInfo?.id,
            goodsId: row?.[0],
          })
          if (res) {
            message.info('替换成功');
            onCancel();
            reloadPage();
            return;
          }
        } catch {
          return;
        }
      },
    })
  }

  return (
    <div className={styles.baseBox}>
      <SDrawerOrModal
        mode="drawer"
        width={'70%'}
        open={open}
        onCancel={() => onCancel()}
        onOk={handleConfirmEditCommodity}
        title="选择商品"
      >
        <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
      </SDrawerOrModal>
    </div>
  )
}
